import { Emitter } from "@core/events/emitter";

export type ToolPoint = readonly [number, number, number];

export interface LaserToolState {
  readonly visible: boolean;
  readonly isHit: boolean;
  readonly origin: ToolPoint;
  readonly target: ToolPoint;
  readonly snapshotId: string | null;
}

const HIDDEN_STATE: LaserToolState = Object.freeze({
  visible: false,
  isHit: false,
  origin: [0, 0, 0] as const,
  target: [0, 0, 0] as const,
  snapshotId: null,
});

/** Headless state shared by Unity's BaseLaserTool-derived web tools. */
export class BaseLaserToolModel {
  readonly onChanged = new Emitter<LaserToolState>();

  private m_state: LaserToolState = HIDDEN_STATE;

  get state(): LaserToolState {
    return this.m_state;
  }

  show(state: Omit<LaserToolState, "visible">): void {
    this.m_state = { ...state, visible: true };
    this.onChanged.emit(this.m_state);
  }

  hide(): void {
    if (!this.m_state.visible) return;
    this.m_state = HIDDEN_STATE;
    this.onChanged.emit(this.m_state);
  }
}
